// Theme tokens — two modes:
//  • internal  → Priority Risk burnt-orange brand
//  • client    → the active client portal's own brand (primary + secondary)
// Layout never changes; only these CSS variables drive colour.

import { fontStack } from "./fonts";

function clamp(n) { return Math.max(0, Math.min(255, Math.round(n))); }
function hexToRgb(hex) {
    const h = (hex || "").replace("#", "");
    const v = h.length === 3 ? h.split("").map((c) => c + c).join("") : h;
    const n = parseInt(v || "000000", 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

function rgbToHex(r, g, b) {
    return "#" + [r, g, b].map((x) => clamp(x).toString(16).padStart(2, "0")).join("");
}

// pct > 0 lightens toward white, pct < 0 darkens toward black.
export function shade(hex, pct) {
    const [r, g, b] = hexToRgb(hex);
    const target = pct < 0 ? 0 : 255;
    const p = Math.abs(pct);
    return rgbToHex(r + (target - r) * p, g + (target - g) * p, b + (target - b) * p);
}

export const INTERNAL_PRIMARY = "#C75A1B";
export const INTERNAL_PRIMARY_DARK = "#9F4212";

const NEUTRALS = {
    "--theme-bg": "#F5F3F0",
    "--theme-panel": "#FFFFFF",
    "--theme-border": "#E5E0DA",
    "--theme-text": "#1F1F1F",
    "--theme-muted": "#6F6A64",
};

export function buildTheme({ isInternalView, client }) {
    if (isInternalView || !client) {
        return {
            ...NEUTRALS,
            "--brand-accent": INTERNAL_PRIMARY,
            "--brand-accent-dark": INTERNAL_PRIMARY_DARK,
            "--theme-secondary": INTERNAL_PRIMARY,
            "--sidebar-bg": INTERNAL_PRIMARY,
            "--sidebar-active-bg": INTERNAL_PRIMARY_DARK,
            "--sidebar-active-border": "transparent",
            "--hero-end": INTERNAL_PRIMARY_DARK,
        };
    }
    const primary = client?.branding?.primary_colour || INTERNAL_PRIMARY;
    const secondary = client?.branding?.secondary_colour || shade(primary, 0.45);
    const headingFont = fontStack(client?.branding?.heading_font);
    const bodyFont = fontStack(client?.branding?.body_font);
    return {
        ...NEUTRALS,
        "--brand-accent": primary,
        "--brand-accent-dark": shade(primary, -0.22),
        "--theme-secondary": secondary,
        "--sidebar-bg": primary,
        "--sidebar-active-bg": "rgba(255,255,255,0.18)",
        "--sidebar-active-border": secondary,
        "--hero-end": shade(primary, 0.16),
        ...(headingFont ? { "--portal-heading-font": headingFont } : {}),
        ...(bodyFont ? { "--portal-body-font": bodyFont } : {}),
    };
}
